import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Finance: React.FC<SvgProps> = (props) => {
  return (
    <Icon width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01471 4.5H8.60294C9.83325 4.5 10.9007 5.18307 11.4571 6.1875H14.0515C17.4795 6.1875 20.25 8.98337 20.25 12.4219C20.25 14.477 19.2606 16.3009 17.7353 17.4362V18.75L16.9853 19.5H13.6324L12.8824 18.75V18.6562H11.8676V18.75L11.1176 19.5H7.76471L7.01471 18.75V16.6859C6.62548 16.2684 6.29265 15.7969 6.02854 15.2836L5.24778 15.2812L4.5 14.5312V10.3125L5.24779 9.5625L6.02854 9.5602C6.29265 9.04685 6.62548 8.57533 7.01471 8.1579V4.5ZM10.3676 18V17.1562H14.3824V18H16.2353V16.6352L16.579 16.4137C17.8849 15.5721 18.75 14.0995 18.75 12.4219C18.75 9.80251 16.6418 7.6875 14.0515 7.6875H10.443L10.2669 7.18598C10.023 6.49143 9.36704 6 8.60294 6H8.51471V8.78262L8.28578 9.00376C7.82295 9.45083 7.45091 9.99205 7.20003 10.5964L7.00866 11.0573L6 11.0603V13.7835L7.00866 13.7864L7.20003 14.2474C7.45091 14.8517 7.82295 15.3929 8.28578 15.84L8.51471 16.0611V18H10.3676Z"
        fill="currentColor"
      />
      <path
        d="M11.25 10.875C11.25 11.4963 10.7463 12 10.125 12C9.50368 12 9 11.4963 9 10.875C9 10.2537 9.50368 9.75 10.125 9.75C10.7463 9.75 11.25 10.2537 11.25 10.875Z"
        fill="currentColor"
      />
    </Icon>
  )
}
